import { render, staticRenderFns } from "./VersionControlItem.vue?vue&type=template&id=268b6056&scoped=true"
import script from "./VersionControlItem.vue?vue&type=script&lang=js"
export * from "./VersionControlItem.vue?vue&type=script&lang=js"
import style0 from "./VersionControlItem.vue?vue&type=style&index=0&id=268b6056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b6056",
  null
  
)

export default component.exports